import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
    state: {
        currentUser: null,
        token: localStorage.getItem('token') || null,
        permissions: [],
    },
    mutations: {
        LOGIN: (state, user) => {
            state.currentUser = user
        },
        LOGOUT(state) {
            this.state.currentUser = null
            localStorage.clear()
            state.tabs = []
            state.token = null
            state.permissions = null
            state.currentUser = null
        },
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
                //localStorage.setItem('perms', permissions.join(','))
        },
    },
    actions: {
        setToken({ commit }, token) {
            commit('SET_TOKEN', token)
        },
        setPermissions({ commit }, permissions) {
            commit('SET_PERMISSIONS', permissions)
        },
        login({ commit }, user) {
            commit('LOGIN', user)
        },
        logout({ commit }) {
            commit("LOGOUT")
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js